// // ============================
// // פילטרים למשתמשים (Users)
// // ============================
// [GlobalSearchCategory.USER]: [

import {QueryUsersData, UsersQueryBuilder, UsersQuerySortBy} from '@data-users';
import {Cached} from '@utils';
import {GlobalSearchCategory, GlobalSearchFilterType, IFilterUpdateResult} from '../types/global-search.types';
import {GlobalSearchAbstractCategory, FilterDefinition, ICategorySortOptions} from './global-search-category-config.abstract';

export class UserCategory extends GlobalSearchAbstractCategory<UsersQueryBuilder, UsersQuerySortBy> {
	public category: GlobalSearchCategory = GlobalSearchCategory.USER;

	public static readonly UserHelperData = QueryUsersData.getQueryUsersData();
	private userHelperData = UserCategory.UserHelperData;

	/* ---------------------- Sorting ---------------------- */
	public static readonly UserSortOptions = this.UserHelperData.Sorting.markers;
	public sortOptions: ICategorySortOptions<UsersQuerySortBy>[] = Object.values(this.userHelperData.Sorting.markers);

	/* ---------------------- Filters ---------------------- */
	private readonly IncludeInactive = new FilterDefinition<UsersQueryBuilder, boolean>({
		type: GlobalSearchFilterType.IncludeInactive,
		labelKey: this.userHelperData.Filters.includeDisabled.label,
		icon: this.userHelperData.Filters.includeDisabled.icon,
		controlType: 'checkbox',
		onValueChanged: (value: boolean | null): IFilterUpdateResult<boolean> => {
			return {
				normalizedValue: value === true ? true : undefined,
				requiresSearch: true,
			};
		},
		applyFilter: (builder: UsersQueryBuilder, value: boolean): void => {
			if (value === true) {
				builder.setIncludeDisabled(value);
			}
		},
	});

	private readonly IncludeTemporary = new FilterDefinition<UsersQueryBuilder, boolean>({
		type: GlobalSearchFilterType.IncludeTemporary,
		labelKey: this.userHelperData.Filters.includeTemporary.label,
		icon: this.userHelperData.Filters.includeTemporary.icon,
		controlType: 'checkbox',
		onValueChanged: (value: boolean | null): IFilterUpdateResult<boolean> => {
			return {
				normalizedValue: value === true ? true : undefined,
				requiresSearch: true,
			};
		},
		applyFilter: (builder: UsersQueryBuilder, value: boolean): void => {
			if (value === true) {
				builder.setIncludeTemporary(value);
			}
		},
	});

	@Cached()
	getFilters(): FilterDefinition<UsersQueryBuilder, any>[] {
		return [this.IncludeInactive, this.IncludeTemporary];
	}
}
